import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useRef,
} from 'react';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import CloseIcon from '@material-ui/icons/Close';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import PrintIcon from '@material-ui/icons/Print';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import AddIcon from '@material-ui/icons/Add';
import RefreshIcon from '@material-ui/icons/Refresh';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import { columnsPayable, columnsReceivable } from './components/Columns';
import GraphQl from '../../GraphQL';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import {
  ACTION_NAME,
  CANCEL_DEFINITIVE,
  FILTER_BY,
  OBJECT_KEYS,
  RECEIVABLE,
  REPORT_PARAMETERS,
  REPORT_TYPES,
  STATUS_CANCELED,
  STATUS_OPENED,
  STATUS_SELECTOR,
} from '../../shared/utils/constants';
import BottomBarInfos from './components/BottomBarInfos';
import AccountsFilter from './components/Filter';
import {
  categoryList,
  contractList,
  financialCancelByInvoicesId,
  financialListByFilter,
  responsibleList,
} from '../../shared/queries/AccountsReceivableAndPayable';
import {
  exportXLSX,
  filterByMatchList,
  generateReport,
  openReport,
} from '../../shared/utils/smartutils';
import SmartContext from '../App/context/SmartContext';
import SmartBaseTable from '../../shared/components/SmartBaseTable/index';
import InvoiceCancelOptions from './components/receivable/InvoiceCancelOptions';
import { useStateWithCallbackLazy } from '../../hooks';
import Modal from '../../shared/components/Modal';
import { accountListByFilterForField } from '../../shared/queries/Account';

const AccountsReceivableAndPayable = (props) => {
  const { t, history, dispatch, type } = props;
  const [data, setData] = useState({ invoices: [] });
  const [selectedData, setSelectedData] = useState([]);
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const [invoiceCancelOptions, setInvoiceCancelOptions] = useState(false);
  const [defaultInvoiceModal, setDefaultInvoiceModal] = useState(false);
  const [categories, setCategories] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [invoicesToCancel, setInvoicesToCancel] = useStateWithCallbackLazy([]);
  const context = useContext(SmartContext);
  const smartBaseTableRef = useRef(null);

  const {
    filterAccountsReceivableAndPayable,
    setAccountsReceivableAndPayable,
  } = context;

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const onFilterToggle = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const addItemClickHandler = () => {
    history.push(`/minime/conta-${type}/mnt/0`);
  };

  const editItemClickHandler = (evt, rowData) => {
    history.push(`/minime/conta-${type}/mnt/${rowData.id}`);
  };

  const onSelectionChange = (selectedItems) => {
    const selectedInvoices = [];
    selectedItems.forEach((invoiceId) => {
      const invoiceIndex = data.invoices.findIndex(
        (invoice) => invoice.id === invoiceId
      );
      if (invoiceIndex && invoiceIndex > 0) {
        selectedInvoices.push(data.invoices[invoiceIndex]);
      }
    });
    setSelectedData(selectedInvoices);
  };

  const loadData = (filter) => {
    if (!filter.initialDate || !filter.finalDate) {
      showNotificationAutoDestroy(
        'warning',
        t('notifications.attention'),
        t('notifications.warning-no-date-selected')
      );
    } else {
      if (filterIsOpen) {
        onFilterToggle();
      }
      showLoading();
      const query = financialListByFilter(filter);
      GraphQl(query, {})
        .then((res) => {
          setData(res.financialListByFilter);
          hideLoading();
        })
        .catch(() => {
          hideLoading();
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        });
    }
  };

  const loadAllCategory = () => {
    const query = categoryList();
    GraphQl(query, {})
      .then((res) => {
        setCategories(res.receivingCategoryListByFilter);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadAllCustomers = () => {
    const query = responsibleList();
    GraphQl(query, {})
      .then((res) => {
        setCustomers(res.responsibleListAll);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadAllContracts = () => {
    const query = contractList(STATUS_SELECTOR.ACTIVE);
    GraphQl(query, {})
      .then((res) => {
        setContracts(res.contractListByFilter);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const getAccountFilter = () => {
    return {
      id: 0,
      filterByStatus: true,
      active: true,
      updaterId: 0,
      checkingAccount: false,
      integrateIfIugu: false,
      smartpay: false,
      defaultAccount: false,
      extraWithdrawalAmount: 0,
      numberWithdrawals: 0,
    };
  };

  const loadAccounts = () => {
    showLoading();
    const query = accountListByFilterForField(getAccountFilter());
    GraphQl(query, {})
      .then((res) => {
        setAccounts(res.accountListByFilter);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const onFilterClickHandler = (filter) => {
    if (filter) {
      setAccountsReceivableAndPayable(filter);
      loadData(filter);
    } else if (filterAccountsReceivableAndPayable) {
      loadData(filterAccountsReceivableAndPayable);
    } else {
      loadData({
        initialDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1,
          0,
          0,
          0,
          0
        ),
        finalDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0,
          0,
          0,
          0
        ),
        type,
        status: [],
        categoryId: { id: 0 },
        clientId: { id: 0 },
        dateFilterType: FILTER_BY.DUE_DATE,
      });
    }
  };

  const filterBuildFunction = () => (
    <AccountsFilter
      filterToggle={onFilterToggle}
      isFiltering={filterIsOpen}
      filterClick={onFilterClickHandler}
      lastFilter={filterAccountsReceivableAndPayable}
      categories={categories}
      customers={customers}
      contracts={contracts}
      accounts={accounts}
      type={type}
    />
  );

  const printOneRegistrationForm = async (evt, rowData) => {
    const formData = new FormData();

    formData.append(REPORT_PARAMETERS.REPORTTYPE, REPORT_TYPES.RELA_RECIBO);
    formData.append(REPORT_PARAMETERS.pCO00TITU, rowData.id);

    showLoading();
    generateReport(formData)
      .then(async (res) => {
        openReport(res.data);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('report.error-generate')
        );
      });
  };

  const printTicket = (evt, rowData) => {
    window.open(rowData.ticketUrl);
  };

  const printRegistrationForm = async (evt, rowData) => {
    const formData = new FormData();

    formData.append(REPORT_PARAMETERS.REPORTTYPE, REPORT_TYPES.RELA_RECIBO);
    formData.append(REPORT_PARAMETERS.pCO00TITU, rowData);

    showLoading();
    generateReport(formData)
      .then(async (res) => {
        openReport(res.data);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('report.error-generate')
        );
      });
  };

  const actionsDisabledByConditional = (propss, customActionsCell) => {
    const reassignCustomActionsCell = [...customActionsCell];
    if (
      propss &&
      propss.column &&
      propss.column.customActionsCell &&
      propss.column.customActionsCell.length
    ) {
      const copyProps = { ...propss };
      reassignCustomActionsCell.find(
        (a) => a.name === ACTION_NAME.PRINT_ONE_RECEIPT
      ).hidden =
        copyProps.rowData.status === STATUS_OPENED ||
        copyProps.rowData.status === STATUS_CANCELED;
      reassignCustomActionsCell.find(
        (a) => a.name === ACTION_NAME.VIEW_TICKET
      ).hidden =
        copyProps.rowData.status === STATUS_CANCELED ||
        !copyProps.rowData.account.smartpay;
    }
  };

  const toggleInvoiceCancelOptions = () => {
    setInvoiceCancelOptions(!invoiceCancelOptions);
  };

  const toggleDefaultInvoiceModal = () => {
    setDefaultInvoiceModal(!defaultInvoiceModal);
  };

  const getSmartPayInvoices = (invoices) => {
    return invoices.filter((invoice) => invoice.account.smartpay);
  };

  const getDefaultInvoices = (invoices) => {
    return invoices.filter((invoice) => !invoice.account.smartpay);
  };

  const callFinancialCancelByInvoices = (ids, cancelType) => {
    const query = financialCancelByInvoicesId(ids, cancelType);
    showLoading();
    GraphQl(query, {})
      .then(() => {
        onFilterClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-cancel')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
        smartBaseTableRef.current.handleSelectAll();
      });
  };
  const invoicesCancelHandler = (invoices, cancelSmartPayType) => {
    const smartPayInvoices = getSmartPayInvoices(invoices).map(
      (invoice) => invoice && invoice.id
    );
    const defaultPayInvoices = getDefaultInvoices(invoices).map(
      (invoice) => invoice && invoice.id
    );
    if (smartPayInvoices.length) {
      callFinancialCancelByInvoices(smartPayInvoices, cancelSmartPayType);
    }
    if (defaultPayInvoices.length) {
      callFinancialCancelByInvoices(defaultPayInvoices, CANCEL_DEFINITIVE);
    }
  };

  const cancelInvoices = (evt, rowsData) => {
    const currentInvoices = [...data.invoices];
    const invoices = filterByMatchList(
      currentInvoices,
      rowsData,
      OBJECT_KEYS.ID
    ).filter((invoice) => invoice.status !== STATUS_CANCELED);
    const hasSmartPay = invoices.some(
      (invoice) =>
        invoice.account.smartpay && invoice.status !== STATUS_CANCELED
    );
    setInvoicesToCancel(invoices, () => {
      if (hasSmartPay) {
        toggleInvoiceCancelOptions();
      } else {
        toggleDefaultInvoiceModal();
      }
    });
  };

  const customActionsToolbar = [
    {
      name: ACTION_NAME.SAVE_ALT,
      icon: <SaveAltIcon />,
      tooltip: t('general.tables.exportXLSXName'),
      callback: () =>
        exportXLSX(
          columnsReceivable(t),
          data.invoices,
          t('screens.mnt_receber.title')
        ),
    },
    {
      name: ACTION_NAME.REFRESH,
      icon: <RefreshIcon />,
      tooltip: t('general.tables.refresh'),
      callback: () => onFilterClickHandler(),
    },

    {
      name: ACTION_NAME.ADD,
      icon: <AddIcon />,
      tooltip: t('general.tables.add_registry'),
      callback: addItemClickHandler,
    },
    {
      name: ACTION_NAME.CLOSE,
      icon: <CloseIcon />,
      tooltip: t('general.tables.billet-cancel'),
      callback: cancelInvoices,
      toolbarOnSelect: true,
    },
    {
      name: ACTION_NAME.PRINT_RECEIPT,
      icon: <PrintIcon />,
      tooltip: t('general.tables.print'),
      callback: printRegistrationForm,
      toolbarOnSelect: true,
    },
  ];

  const customActionsCell = [
    {
      name: ACTION_NAME.PRINT_ONE_RECEIPT,
      icon: <PrintIcon />,
      tooltip: t('report.parameters.print-receipt'),
      callback: printOneRegistrationForm,
    },
    {
      name: ACTION_NAME.VIEW_TICKET,
      icon: <FileCopyIcon />,
      tooltip: t('general.print-ticket'),
      callback: printTicket,
    },
  ];

  useEffect(() => {
    onFilterClickHandler();
    loadAllCategory();
    loadAllCustomers();
    loadAllContracts();
    loadAccounts();
  }, []);

  return (
    <Fragment>
      <Container>
        <Modal
          color="warning"
          title={t('notifications.attention')}
          btn="Warning"
          message={t('notifications.cancel-invoices')}
          toggle={toggleDefaultInvoiceModal}
          modal={defaultInvoiceModal}
          onConfirm={() => {
            toggleDefaultInvoiceModal();
            invoicesCancelHandler(invoicesToCancel, CANCEL_DEFINITIVE);
          }}
        />
        <InvoiceCancelOptions
          isOpen={invoiceCancelOptions}
          toggle={toggleInvoiceCancelOptions}
          onConfirm={(cancelType) => {
            toggleInvoiceCancelOptions();
            invoicesCancelHandler(invoicesToCancel, cancelType);
          }}
        />
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap overflow-hidden">
                  <SmartBaseTable
                    ref={smartBaseTableRef}
                    title={t('screens.mnt_receber.title')}
                    columns={
                      type === RECEIVABLE
                        ? columnsReceivable(t)
                        : columnsPayable(t)
                    }
                    isFiltering={filterIsOpen}
                    onAddClick={addItemClickHandler}
                    filterBuildFunction={filterBuildFunction}
                    onFilterClick={onFilterToggle}
                    onSelectionChange={onSelectionChange}
                    data={data.invoices}
                    onEditCell={editItemClickHandler}
                    onRefreshClick={onFilterClickHandler}
                    customActionsToolbar={customActionsToolbar}
                    customActionsCell={customActionsCell}
                    actionsDisabledByConditional={actionsDisabledByConditional}
                    footerHeight={160}
                    customFooterBar={
                      type === RECEIVABLE && (
                        <BottomBarInfos
                          receiving={data.amountToReceiveInFormat}
                          expired={data.owedAmountInFormat}
                          amountReceived={data.receivedAmountInFormat}
                          numberOfRecords={data.numberOfRecords}
                          selectedItems={selectedData}
                        />
                      )
                    }
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

AccountsReceivableAndPayable.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(AccountsReceivableAndPayable)
);
